export function SettingIcon({
  icon,
  color,
  size = 32,
}: {
  icon: string;
  color: string;
  size?: number;
}) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: size * 0.25,
        background: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        // Clip the glyph to the chip - some f7-icons (e.g. `clock`) have ink that
        // extends past their advance width and would otherwise bleed past the box.
        overflow: 'hidden',
      }}
    >
      <i className="f7-icons" style={{ fontSize: size * 0.56, lineHeight: 1, color: '#fff' }}>
        {icon}
      </i>
    </div>
  );
}
